"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const fdr_regular_fusion_fdr_catalogs_list_1 = require("@hotelplan/fdr.regular.fusion.fdr-catalogs-list");
const fdr_lib_track_catalog_1 = require("@hotelplan/fdr.lib.track.catalog");
const fdr_catalogs_content_styles_1 = require("./fdr-catalogs-content.styles");
const fdr_catalogs_content_utils_1 = require("./fdr-catalogs-content.utils");
function FdrCatalogsContent({ onSubmit, catalogs, loading, openErrorModal, api, isCaptchaEnabled, cardConfig, orderConfig, }) {
    const [isOrderSectionOpen, openOrderSection, closeOrderSection,] = (0, libs_hooks_react_1.useToggleState)(false);
    const [orderedCatalogs, setOrderedCatalogs] = (0, react_1.useState)([]);
    const catalogToOrderIds = orderedCatalogs.map(({ id }) => id);
    const track = (0, fdr_lib_track_catalog_1.trackCart)(orderedCatalogs);
    const { layoutComponent: OrderLayoutComponent } = orderConfig;
    const addCatalogToOrdered = (catalog, position) => {
        const newOrderedCatalogs = (0, fdr_catalogs_content_utils_1.addNewCatalog)(catalog, orderedCatalogs);
        if (!(0, fdr_catalogs_content_utils_1.areCatalogsValid)(newOrderedCatalogs)) {
            return openErrorModal();
        }
        (0, fdr_lib_track_catalog_1.trackCatalog)(catalog, position).add();
        setOrderedCatalogs(newOrderedCatalogs);
    };
    const removeCatalogFromOrdered = (catalog, position) => {
        const newOrderedCatalogs = (0, fdr_catalogs_content_utils_1.removeCatalog)(catalog, orderedCatalogs);
        if (position === undefined) {
            (0, fdr_lib_track_catalog_1.trackCart)(newOrderedCatalogs).cart();
        }
        else {
            (0, fdr_lib_track_catalog_1.trackCatalog)(catalog, position).remove();
        }
        setOrderedCatalogs(newOrderedCatalogs);
        if (!newOrderedCatalogs.length) {
            closeOrderSection();
        }
    };
    const swapOrderedCatalog = (prev, next) => {
        const prevIndex = orderedCatalogs.findIndex(item => item.id === prev.id);
        const nextOrderedCatalogs = orderedCatalogs.slice(0);
        nextOrderedCatalogs[prevIndex] = Object.assign(Object.assign({}, next), { variants: [Object.assign({}, next), Object.assign({}, prev)] });
        setOrderedCatalogs(nextOrderedCatalogs);
    };
    if (api) {
        api.current = {
            catalogToOrderIds,
            setOrderedCatalogs,
            closeOrderSection,
            track,
        };
    }
    const openOrderSectionAndTrack = () => {
        track.cart();
        openOrderSection();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loading ? (react_1.default.createElement(fdr_regular_fusion_fdr_catalogs_list_1.CatalogsListSkeleton, null)) : (react_1.default.createElement(fdr_catalogs_content_styles_1.CatalogsWrap, null,
            react_1.default.createElement(fdr_regular_fusion_fdr_catalogs_list_1.FdrCatalogsList, { orderedCatalogs: orderedCatalogs, catalogs: catalogs, onAdd: addCatalogToOrdered, onRemove: removeCatalogFromOrdered, cardConfig: cardConfig }))),
        react_1.default.createElement(OrderLayoutComponent, { orderedCatalogs: orderedCatalogs, onSubmit: onSubmit, catalogToOrderIds: catalogToOrderIds, isCaptchaEnabled: isCaptchaEnabled, isOrderSectionOpen: isOrderSectionOpen, openOrderSection: openOrderSectionAndTrack, closeOrderSection: closeOrderSection, removeCatalogFromOrdered: removeCatalogFromOrdered, swapOrderedCatalog: swapOrderedCatalog, orderConfig: orderConfig })));
}
exports.default = FdrCatalogsContent;
//# sourceMappingURL=fdr-catalogs-content.js.map